import { Col, Row, Divider, Typography } from "antd";
import styles from "@styles/variables.module.scss";
import { InvestmentHub } from "./Components/InvestmentHub/InvestmentHub";
import { MarketPlace } from "./Components/MarketPlace/MarketPlace";
import { KnowledgeHub } from "./Components/KnowledgeHub/KnowledgeHub";
import { AppFooter } from "./Components/Footer/Footer";
import { PlatformFusion } from "./Components/PlatformFusion/PlatformFusion";
import { TeamCards } from "./Components/Team/Team";
import { ESGTools } from "./Components/ESGTools/ESGTools";
import { SustainableFinanceFramework } from "./Components/SustainableFinanceFramework/SustainableFinanceFramework";
import LogoGallery from "./Components/Logo/Logos";
import AsiaMap from "./Components/Map/Map";
import { SustainableMaterial } from "./Components/SustainableMaterials/SustainableMaterial";

export const LandingPage = () => {
  const investors = (
    <Typography.Title level={5}>
      More than
      <span style={{ color: "#49926F" }}> 450+ </span>
      Investors & Partners
    </Typography.Title>
  );

  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  return (
    <>
      <PlatformFusion />
      <LogoGallery element={investors} />
      <InvestmentHub />
      <SustainableFinanceFramework />
      <ESGTools />
      {/* <SustainableMaterial /> */}
      <KnowledgeHub />
      <TeamCards />
      <LogoGallery element={leadingBanks} />
      <AppFooter />
    </>
  );
};
